import React, { useState, useEffect } from "react";
import { Modal, Table, Tag, message } from "antd";
import { HistoryOutlined } from "@ant-design/icons";
import useAxios from "../../utilities/useAxios";
import dayjs from "dayjs";

const ViewCellChangeRecordsModal = ({
	visible,
	onCancel,
	userId,
	userName,
}) => {
	const [records, setRecords] = useState([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (visible && userId) {
			fetchRecords();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps -- run only when visible/userId
	}, [visible, userId]);

	const fetchRecords = async () => {
		try {
			setLoading(true);
			const response = await useAxios.get(
				`/users/cell-change-records/${userId}/`
			);
			if (response.status === 200) {
				setRecords(response.data);
			}
		} catch (error) {
			message.error(
				"구역 변경 기록을 불러오는데 실패했습니다."
			);
		} finally {
			setLoading(false);
		}
	};

	const columns = [
		{
			title: "변경일",
			dataIndex: "changed_date",
			key: "changed_date",
			render: (date) => dayjs(date).format("YYYY-MM-DD"),
			sorter: (a, b) =>
				dayjs(a.changed_date).unix() -
				dayjs(b.changed_date).unix(),
			defaultSortOrder: "descend",
		},
		{
			title: "변경된 구역",
			dataIndex: "changed_cell",
			key: "changed_cell",
			render: (cell) => <Tag color="purple">{cell}</Tag>,
		},
		{
			title: "변경 사유",
			dataIndex: "reason",
			key: "reason",
			render: (reason) => reason || "-",
		},
	];

	return (
		<Modal
			title={
				<div
					style={{
						display: "flex",
						alignItems: "center",
						gap: "8px",
					}}>
					<HistoryOutlined />
					<span>
						{userName}님의 구역 변경 기록
					</span>
				</div>
			}
			open={visible}
			onCancel={onCancel}
			footer={null}
			width={800}>
			<Table
				columns={columns}
				dataSource={records}
				rowKey="id"
				loading={loading}
				pagination={{
					pageSize: 10,
					showSizeChanger: true,
					showQuickJumper: true,
					showTotal: (total, range) =>
						`${range[0]}-${range[1]} / 총 ${total}개`,
				}}
				locale={{
					emptyText: "변경 기록이 없습니다.",
				}}
			/>
		</Modal>
	);
};

export default ViewCellChangeRecordsModal;
